interface TimeLeft {
  hours: number
  minutes: number
  seconds: number
}

export const calculateTimeLeft = (endTime: Date): TimeLeft => {
  const end = endTime.getTime()
  const now = Date.now()
  const diff = Math.max(0, end - now)

  const totalSeconds = Math.floor(diff / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return { hours, minutes, seconds }
}
